<template>
  <div>
    <b-row>
      <b-col md="6">
        <b-card>
          <label>
            <b>Campaign</b>
          </label>
          <b-table
            responsive
            show-empty
            hover
            ref="applicationTable"
            :items="getDataApplication"
            :fields="typesApplication"
            :current-page="currentPageApplication"
            :per-page="perPageApplication"
            :sort-by.sync="sortByApplication"
            :sort-desc.sync="sortDescApplication"
            :sort-direction="sortDirectionApplication"
            head-variant="light"
            class="bg-white"
          >
            <div slot="table-busy" class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
            <template v-slot:cell(application_name)="{ item }">
              <p class="mb-0">{{item.application_name}}</p>
            </template>
            <template v-slot:cell(campaign_name)="{ item }">
              <p class="mb-0">{{item.campaign_name}}</p>
            </template>
            <template v-slot:cell(campaign_id)="{ item }">
              <p class="mb-0">{{item.campaign_id}}</p>
            </template>
            <template v-slot:cell(status)="{ item }">
              <p class="mb-0">
                <span v-if="item.status == 'enabled'" class="text-success">{{item.status}}</span>
                <span v-else-if="item.status == 'disabled'" class="text-danger">{{item.status}}</span>
                <span v-else>{{item.status}}</span>
              </p>
            </template>
            <template v-slot:cell(action)="{item}">
              <b-link v-b-tooltip.hover title="See Voucher" class="text-dark" @click="selectCampaign(item.application_id, item.campaign_id, item.campaign_name)">
                <img src="@/assets/ic-view.png" class="mr-2" alt />
              </b-link>
            </template>
          </b-table>
          <b-row class="mx-auto">
            <b-col md="4" align="left" class="mx-auto px-0">
              <div v-if="totalRowsApplication == 0 || totalRowsApplication == null">
                Showing 0 Records
              </div>
              <div v-else>
                Showing {{ fromPageApplication[currentPageApplication - 1] }} to
                {{ toPageApplication[currentPageApplication - 1] }} of {{ totalRowsApplication }} Records
              </div>
            </b-col>
            <b-col md="4" class="mx-auto"></b-col>
            <b-col md="4" align="right" class="px-0">
              <b-pagination
                align="right"
                v-model="currentPageApplication"
                :total-rows="totalRowsApplication"
                :per-page="perPageApplication"
                class="my-0"
              ></b-pagination>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col md="6">
        <b-card v-if="campaign_id_selected !== ''">
          <label>
            <b>Voucher {{campaign_name_selected}}</b>
          </label>
          <b-table
            responsive
            show-empty
            hover
            ref="nonUniversalVoucherTable"
            :items="getDataNonUniversalVoucher"
            :fields="typesNonUniversal"
            head-variant="light"
            class="bg-white"
          >
            <div slot="table-busy" class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
            <template v-slot:cell(voucher_name)="{ item }">
              <p class="mb-0">{{item.voucher_name}}</p>
            </template>
            <template v-slot:cell(usage)="{ item }">
              <p class="mb-0">{{item.usage_counter}}/{{item.usage_limit}}</p>
            </template>
            <template v-slot:cell(action)="{item}">
              <b-link v-b-tooltip.hover title="Reserve" class="text-dark" @click="showModalReserveNonUniversalVoucher(item.voucher_name, item.notification_message)">
                <span class="btn btn-primary btn-sm">Reserve Voucher</span>
              </b-link>
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      v-model="modalReserveVoucherNonUniversalShow"
      size="l"
      hide-header
      hide-footer
      no-close-on-esc
      no-close-on-backdrop>
      <div class="container">
        <b-row>
          <b-col>
            <h2 class="font-weight-bold">Reserve Voucher</h2>
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col>
            <b-form-group
              id="fieldset-1"
              label-class="control-label"
              class="font-weight-bold"
              label="Voucher Name"
              label-for="input-1"
              style="font-size: 12px"
            >
              <input
                v-model="non_universal_voucher_name"
                v-validate="'required'"
                name="non_universal_voucher_name"
                data-vv-as="Voucher Name"
                id="non_universal_voucher_name"
                class="form-control"
                placeholder="Voucher Name"
                disabled
              />
            <b-form-invalid-feedback id="input-non_universal_voucher_name-feedback">{{
              veeErrors.first("non_universal_voucher_name")
            }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="menu === 'userapp'">
          <b-col>
            <b-form-group
              id="fieldset-1"
              label-class="control-label"
              class="font-weight-bold"
              label="Notification Message"
              label-for="textarea_notification_message"
              style="font-size: 12px"
            >
              <b-form-textarea
                id="textarea_notification_message"
                v-model="non_universal_notification_message"
                name="notification_message"
                data-vv-as="Notification Message"
                placeholder="Notification Message"
                rows="3"
                max-rows="3"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mb-4">
          <b-col md="3">
            <b-button :variant="input === 'manual' ? 'primary':'light'" block @click="changeInput('manual')">Manual Input</b-button>
          </b-col>
          <b-col md="3">
            <b-button :variant="input === 'csv' ? 'primary':'light'" block @click="changeInput('csv')">CSV Upload</b-button>
          </b-col>
          <b-col md="6" style="align-self: center;">
            <a href="@/assets/reservation_template.csv" download style="text-decoration: none;">
              <span class="text-primart font-weight-bold">Download CSV Template</span>
            </a>
          </b-col>
        </b-row>
        <div v-if="input === 'csv'" class="align-items-center">
          <input
            type="file"
            ref="uploadCsv"
            v-validate="`required`"
            name="csv_member_codes"
            data-vv-as="CSV Member Codes"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            @change="changeToJSON"
          />
          <br>
          <b-form-invalid-feedback id="input-csv_member_codes-feedback">{{
              veeErrors.first("csv_member_codes")
            }}</b-form-invalid-feedback>
        </div>
        <b-row v-else-if="input === 'manual'">
          <b-col>
            <b-form-group
              id="fieldset-1"
              label-class="control-label"
              class="font-weight-bold"
              label="Member Codes (separate by enter)"
              label-for="input-1"
              style="font-size: 12px"
            >
              <b-form-textarea
                id="textarea"
                v-model="non_universal_member_codes"
                v-validate="`required|maxRowTextArea:${maxMemberCodesLength}`"
                name="member_codes"
                data-vv-as="Member Codes"
                placeholder="Member Codes"
                rows="10"
                max-rows="15"
              ></b-form-textarea>
              <p style="display:flex;justify-content: space-between;">
                <span style="width:100%;margin-top:.25rem;font-size: 80%;color: #e74a3b;">{{ veeErrors.first('member_codes') }}</span>
                <span class="text-right">{{memberCodesLength}}/{{maxMemberCodesLength}}</span>
              </p>
            </b-form-group>
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col>
            <b-button
              variant="light"
              :disabled="loading_reserve_non_universal_voucher"
              @click="modalReserveVoucherNonUniversalShow = !modalReserveVoucherNonUniversalShow"
              class="text-primary"
              block
              size="lg"
              >Close</b-button
            >
          </b-col>
          <b-col>
            <b-button
              variant="primary"
              :disabled="loading_reserve_non_universal_voucher"
              @click="reserveNonUniversalVoucher()"
              block
              size="lg"
            >
              <b-spinner v-if="loading_reserve_non_universal_voucher" small label="Loading..."></b-spinner>
              <span v-else>Save & Run</span>
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>

export default {
  data() {
    return {
      loading_application: true,
      loading_non_universal: true,
      loading_reserve_non_universal_voucher: false,
      modalReserveVoucherNonUniversalShow: false,
      applications: [],
      non_universal_vouchers: [],
      typesApplication: [
        {
          key: "application_name",
          label: "Application",
          sortable: false,
          class: "text-left"
        },
        {
          key: "campaign_name",
          label: "Campaign Name",
          sortable: false,
          class: "text-left"
        },
        {
          key: "campaign_id",
          label: "ID",
          sortable: false,
          class: "text-left"
        },
        {
          key: "status",
          label: "Status",
          sortable: false,
          class: "text-left"
        },
        { key: "action", label: "Action", class: "text-center w-10" }
      ],
      typesNonUniversal: [
        {
          key: "voucher_name",
          label: "Voucher Name",
          sortable: false,
          class: "text-left w-50"
        },
        {
          key: "usage",
          label: "Usage",
          sortable: false,
          class: "text-left"
        },
        { key: "action", label: "Action", class: "text-center w-30" }
      ],
      fromPageApplication: [],
      toPageApplication: [],
      totalRowsApplication: 0,
      currentPageApplication: 1,
      perPageApplication: 10,
      sortByApplication: null,
      sortDescApplication: true,
      sortDirectionApplication: "asc",
      application_id_selected: "",
      campaign_id_selected: "",
      campaign_name_selected: "",
      non_universal_voucher_name: "",
      non_universal_member_codes: "",
      non_universal_notification_message: "",
      maxMemberCodesLength: 50000,
      input: "manual",
      menu: "",
      data_csv: [],
    }
  },
  methods: {
    getDataApplication(ctx, callback) {
      this.loading_application = true;
      const vm = this;
      const formData = new FormData();
      var app_name = ''
      if(this.menu ==='userapp'){
        app_name = 'Paxel-UA'
      } else {
        app_name = 'PaxelMarket3'
      }
      // formData.append("search_param", ctx.filter);
      formData.append("limit", ctx.perPage);
      formData.append("page", ctx.currentPage);
      formData.append("app_name", app_name);
      this.$store
        .dispatch("VoucherModule/getCampaignWithPaging", formData)
        .then(response => {
          vm.totalRowsApplication = response.data.data.total_record;
          var from = [];
          var to = [];
          var sum = 0;
          for (let i = 1; i <= vm.currentPageApplication; i++) {
            sum = i * vm.perPageApplication;
            if (vm.totalRowsApplication <= sum) {
              from.push(sum - vm.perPageApplication + 1);
              to.push(vm.totalRowsApplication - sum + sum);
            } else {
              from.push(sum - vm.perPageApplication + 1);
              to.push(sum);
            }
          }
          this.fromPageApplication = from;
          this.toPageApplication = to;
          this.applications = response.data.data.results || [];
          callback(response.data.data.results || []);
          this.loading_application = false;
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "Error!",
            text: error.response ? error.response.data.message : "Failed get campaigns",
            showConfirmButton: false,
            timer: 1500,
          });
          this.loading_application = false;
          callback([]);
        });
      return null;
    },
    getDataNonUniversalVoucher(ctx, callback) {
      this.loading_non_universal = true;
      const vm = this;
      const formData = new FormData();
      // formData.append("search_param", ctx.filter);
      // formData.append("limit", ctx.perPage);
      // formData.append("page", ctx.currentPage);
      formData.append("campaign_id", this.campaign_id_selected);
      formData.append("application_id", this.application_id_selected);
      this.$store
        .dispatch("VoucherModule/getNonUniversalVouchers", formData)
        .then(response => {
          this.non_universal_vouchers = response.data.data.results || [];
          callback(response.data.data.results || []);
          this.loading_non_universal = false;
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "Error!",
            text: error.response ? error.response.data.message : "Failed get non universal voucher",
            showConfirmButton: false,
            timer: 1500,
          });
          this.loading_non_universal = false;
          callback([]);
        });
      return null;
    },
    selectCampaign(application_id, campaign_id, campaign_name) {
      this.application_id_selected = application_id;
      this.campaign_id_selected = campaign_id;
      this.campaign_name_selected = campaign_name
      if (this.$refs.nonUniversalVoucherTable) {
        this.$refs.nonUniversalVoucherTable.refresh();
      }
    },
    showModalReserveNonUniversalVoucher(voucher_name, notification_message) {
      this.non_universal_voucher_name = voucher_name;
      this.non_universal_member_codes = "";
      this.non_universal_notification_message = notification_message;
      this.modalReserveVoucherNonUniversalShow = !this.modalReserveVoucherNonUniversalShow;
    },
    reserveNonUniversalVoucher() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$swal({
            text: `Are you sure want to run the ${this.non_universal_voucher_name} reserve?`,
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#6051a2",
            cancelButtonColor: "#f8f9fc",
            cancelButtonClass: "text-primary",
            confirmButtonText: "Confirm",
            scrollbarPadding: false,
          }).then(result => {
            if (result.value) {
              this.loading_reserve_non_universal_voucher = true;
              const formData = new FormData();
              var app_name = ''
              var notif = ''
              var non_universal_member_codes_list
              if(this.menu ==='userapp'){
                app_name = 'Paxel-UA'
                notif = this.non_universal_notification_message
              } else {
                app_name = 'PaxelMarket3'
                notif = ''
              }
              if (this.input == 'csv'){
                var data = this.data_csv.map((x) => {
                  return x.member_code;
                });
                non_universal_member_codes_list = data
              } else {
                non_universal_member_codes_list = this.non_universal_member_codes.replace(/^\s+|\s+$|[^\S\r\n]/g,'').replace(/[\r\n]{2,}/g, '\r\n').split(/\r?\n/);
              }
              var payload = {
                app_name:app_name,
                voucher_name:this.non_universal_voucher_name,
                notification_message:notif,
                member_codes:non_universal_member_codes_list,
              }
              
              this.$store
                .dispatch("VoucherModule/reserveNonUniversalVoucher", payload)
                .then((response) => {
                  this.loading_reserve_non_universal_voucher = false;
                  this.modalReserveVoucherNonUniversalShow = false;
                  this.$refs.nonUniversalVoucherTable.refresh();
                  this.$swal({
                    type: "success",
                    title: "Your non universal reserve has been sent",
                    showConfirmButton: false,
                    scrollbarPadding: false,
                    timer: 1500,
                  });
                })
                .catch((error) => {
                  this.loading = false;
                  this.$swal({
                    type: "error",
                    title: "Oops...",
                    text: error.response ? error.response.data.message : "Failed reserve non universal voucher",
                    showConfirmButton: false,
                    scrollbarPadding: false,
                    timer: 1500,
                  });
                  this.loading_reserve_non_universal_voucher = false;
                });
            }
          });
        } else {
          this.$swal("ERROR!", "Your data can not be submitted.", "warning");
        }
      });
    },
    changeToJSON(e) {
      const inputRefFiles = this.$refs.uploadCsv.files[0];
      if (!inputRefFiles) return;
      let lines = "";
      let currentLine = "";
      let csv = null;
      let headers = "";
      let result = [];
      let reader = new FileReader();
      reader.readAsBinaryString(inputRefFiles);
      reader.onload = (evt) => {
        csv = reader.result;
        lines = csv.split("\n");
        headers = lines[0].split(";");
        if (lines[0].split(",").length > 1) {
          headers = lines[0].split(",");
        }
        
        for (let i = 1; i < 50001; i++) {
          if (!lines[i]) continue;
          let obj = {};
          currentLine = lines[i];
          let re = /"/g;
          let tempLine = re[Symbol.replace](currentLine, "");
          currentLine = tempLine.split(";");
          if (lines[0].split(",").length > 1) {
            currentLine = tempLine.split(",");
          }
          
          for (let j = 0; j < headers.length; j++) {
            let head = ""
            let value = ""
            if(headers[j]){
              head = headers[j].trim();
            }
            if(currentLine[j]){
              value = currentLine[j].trim();
            }
            obj[head] = value;
          }
          result.push(obj);
        }
        this.data_csv = result;
      };
    },
    changeInput(val){
      this.input = val
    }
  },
  computed: {
    memberCodesLength() {
      if (this.non_universal_member_codes == '') {
        return 0;
      }
      const non_universal_member_codes_list = this.non_universal_member_codes.replace(/^\s+|\s+$|[^\S\r\n]/g,'').replace(/[\r\n]{2,}/g, '\r\n').split(/\r?\n/);
      return non_universal_member_codes_list.length;
    }
  },
  mounted() {
    this.menu = this.$parent.$parent.tab_menu
  },
};
</script>